<div class="container dp-sp-block">
    <div class="count-box">
        <span class="title">Dp Sp Receiving</span>
        <div class="country-option-line">
            <div class="country-btn" (click)="onClickCountry('ind')" [ngClass]="{'active-country-btn': isCountryIndia}">
                India</div>
            <div class="country-btn" (click)="onClickCountry('foreign')"
                [ngClass]="{'active-country-btn': isCountryForeign}">Foreign</div>
            @if(isReportPermission){
            <div class="country-btn" (click)="onClickReport()" [ngClass]="{'active-country-btn': isReport}">Receiving
                Report</div>
            }
        </div>

        <form [formGroup]="workerForm">
            @if (isCountryIndia){
            <div class="worker-inp-group">
                <label>Worker fc</label>
                <input type="number" class="text-input" placeholder="Search by worker family code"
                    (keyup)="onEnterWorkerFamilyCode($event)" formControlName="workerFc">
            </div>
            }

            @if (isCountryForeign){
            <div class="worker-inp-row">
                <div class="worker-inp-group">
                    <label>Country</label>
                    <select class="form-select" aria-label="Default select" [formControl]="workerCountry">
                        <option selected value="">--select country--</option>
                        <option *ngFor="let country of foreignCountries" value="{{country}}">{{country}}</option>
                    </select>
                </div>

                <div class="worker-inp-group">
                    <label>Worker name</label>
                    <input type="text" class="text-input" placeholder="Search by worker name"
                        [formControl]="searchedName" [matAutocomplete]="auto" (keyup)="onPressWorkername($event)">

                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                        @for (worker of workerDetails ; track worker) {
                        <mat-option (click)="automatedDropVal(worker)" [value]="worker.fullName">{{
                            worker.fullName
                            }} ({{worker.workerType}})</mat-option>
                        }
                    </mat-autocomplete>
                </div>
            </div>
            }
        </form>
    </div>

    @if(isDataPresent){
    <div class="worker-details">
        <span class="welcome-text">Jayguru, {{selectedWorkerDetails.dwd_worker_name ||
            selectedWorkerDetails.fullName}}</span>

        <div class="worker-tiles-row">
            <div class="worker-tiles">
                <span class="tiles-title">Worker Name</span>
                <span class="title-value">{{selectedWorkerDetails.dwd_worker_name ||
                    selectedWorkerDetails.fullName}}</span>
            </div>

            <div class="worker-tiles">
                <span class="tiles-title">Family Code</span>
                <span class="title-value">{{selectedWorkerDetails.dwd_family_code ||
                    selectedWorkerDetails.ritwikCode}}</span>
            </div>

            <div class="worker-tiles">
                <span class="tiles-title">Mobile number</span>
                <span class="title-value">{{selectedWorkerDetails.mob || selectedWorkerDetails.contactNo ||
                    'NA'}}</span>
            </div>
        </div>

        <div class="worker-tiles-row">
            <div class="worker-tiles">
                <span class="tiles-title">Worker District</span>
                <span class="title-value">{{selectedWorkerDetails.dwd_district_name || selectedWorkerDetails.district ||
                    'NA'}}</span>
            </div>

            <div class="worker-tiles">
                <span class="tiles-title">Worker State</span>
                <span class="title-value">{{selectedWorkerDetails.dwd_state_name || selectedWorkerDetails.state ||
                    'NA'}}</span>
            </div>

            <div class="worker-tiles">
                <span class="tiles-title">Worker pin</span>
                <span class="title-value">{{selectedWorkerDetails.pin || selectedWorkerDetails.pincode || 'NA'}}</span>
            </div>
        </div>

        <form [formGroup]="countForm" class="count-box" (submit)="onSubmitCount()">
            <div class="count-row">
                <div class="count-inp-group">
                    <label>Diksha Patra Count</label>
                    <input type="number" class="text-input" placeholder="Enter diksha patra count"
                        formControlName="dpCount">

                    <div class="count-inp-group">
                        <div class="count-radio-checked">
                            <div class="check-group">
                                <div [ngClass]="{'radio-box': !isDpCountChecked, 'radio-box-active': isDpCountChecked}"
                                    (click)="onClickDpChecked()"></div>
                                <span class="check-text">Verified count</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="count-inp-group">
                    <label>Swastyayani Patra Count</label>
                    <input type="number" class="text-input" placeholder="Enter swastyayani patra count"
                        formControlName="spCount">

                    <div class="count-inp-group">
                        <div class="count-radio-checked">
                            <div class="check-group">
                                <div [ngClass]="{'radio-box': !isSpCountChecked, 'radio-box-active': isSpCountChecked}"
                                    (click)="onClickSpChecked()"></div>
                                <span class="check-text">Verified count</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            @if(isShowErrorMessage){
            <span class="error-msg">Both DP & SP count can not be blank.</span>
            }
            <button>Submit</button>
        </form>
    </div>
    }

    @if (isReport) {
    <app-dp-sp-receiving-report></app-dp-sp-receiving-report>
    }
</div>